export function useUiDialog(name: string, settings?: any) {
  const dialog = useState<HTMLDialogElement | undefined>(`uiDialog__${name}`, () => undefined)
  const dialogSettings = useState(`uiDialogSettings__${name}`, () => ({
    top: 0,
    isOpen: false,
    type: 'dialog',
  }))

  if (settings) {
    dialogSettings.value = settings
  }

  const open = () => {
    dialogSettings.value = {
      ...dialogSettings.value,
      top: window.scrollY,
    }

    if (dialogSettings.value.type === 'dialog') {
      dialog.value?.show()
    }
    else {
      dialog.value?.showModal()
    }

    dialogSettings.value = {
      ...dialogSettings.value,
      isOpen: true,
    }
  }

  const close = () => {
    dialogSettings.value = {
      ...dialogSettings.value,
      isOpen: false,
    }

    dialog.value?.close()
  }

  const onClickOutside = (event: MouseEvent): void => {
    if (!dialog.value) {
      close()
      return
    }

    if (dialogSettings.value.type === 'dialog') {
      return
    }

    const dialogDimensions = dialog.value.getBoundingClientRect()

    if (
      event.clientX < dialogDimensions.left
      || event.clientX > dialogDimensions.right
      || event.clientY < dialogDimensions.top
      || event.clientY > dialogDimensions.bottom
    ) {
      close()
    }
  }

  return {
    dialog,
    settings: dialogSettings,
    open,
    close,
    onClickOutside,
  }
}
